import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PspSortingListFilter } from '@/models/psp-sorting/psp-sorting-filter.model';
import { PspSortingListItem } from '@/models/psp-sorting/psp-sorting.model';

export default class GetPspSortingListRequest extends ApiResourceMethod<PspSortingListItem[]> {
  public perform(filterList: PspSortingListFilter): Promise<PspSortingListItem[]> {
    const params = {
      filterList,
    };

    return this.performer.requestWithMapper(
      { params },
      (response: BaseResponse<PspSortingListItem[]>) => response.data,
    );
  }
}
